import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Home from '../pages/home'
import GetHelp from '../pages/gethelp/gethelp.js'
export default () => (
  <Switch>
    <Route exact path="/" component={Home} />
    {/* <Route exact path="/gethelp" component={GetHelp} />  */} {/* for feature if scan QR code it will automatic show gethelp widget */}
  </Switch>
)